import _ from 'lodash';
import { connect } from 'react-redux';
import { isInFullScreen } from '../../selectors/player';

import React from 'react';
import PropTypes from 'prop-types';

const mapStateToProps = (state) => ({
  isInFullScreen: isInFullScreen(state),
});

export default connect(mapStateToProps)(
  class ContainerSize extends React.Component {
    static propTypes = {
      children: PropTypes.func.isRequired,
      className: PropTypes.string,
      isInFullScreen: PropTypes.bool,
    };

    constructor(props) {
      super(props);

      this.state = {
        width: null,
        height: null,
      };

      this.containerRef = null;
      this.interval = null;
    }

    componentDidMount() {
      // TODO: fix me!!!
      this.interval = setInterval(this.updateSize, 300);
      this.updateSize();
    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }

    saveContainerRef = (ref) => {
      this.containerRef = ref;
    };

    getContainerSize() {
      return {
        width: Math.ceil(_.get(this.containerRef, 'clientWidth', 0)),
        height: Math.ceil(_.get(this.containerRef, 'clientHeight', 0)),
      };
    }

    updateSize = () => {
      const size = this.getContainerSize();

      if (_.isEqual(size, this.state)) {
        return;
      }

      // TODO: dirty hack to prevent exiting fullscreen for FB videos
      // https://jira.wixpress.com/browse/VOD-3353
      if (this.props.isInFullScreen) {
        return;
      }

      this.setState(size);
    };

    render() {
      const { className, children } = this.props;

      return (
        <div ref={this.saveContainerRef} className={className}>
          {children(this.state)}
        </div>
      );
    }
  },
);
